import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router';

function FundingsQuickAccessForm() {
  const navigate = useNavigate();

  return (
    <Form.Control
      className="bo-input bo-w-120"
      type="quickAccess"
      name="quickAccess"
      placeholder="Advance ID"
      onKeyDown={e => {
        if (e.code === 'Enter' && e.target.value !== '') {
          navigate(`/funding/${e.target.value}`);
        }
      }}
    />
  );
}

export default FundingsQuickAccessForm;
